import { useEffect } from 'react';
import { useAppDispatch } from '../redux';
import { fetchUserGeoLocation } from '../redux/userGeoLocation';

export const useFetchUserGeoLocation = () => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(fetchUserGeoLocation());
  }, []);
};
